import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@elaniintc/goes-design-system";

const TooltipWrapper = ({
  children,
  title,
  position = "right",
}: {
  children: React.ReactNode;
  title: string;
  position?: "top" | "bottom" | "left" | "right";
}) => {
  return (
    <Tooltip>
      <TooltipTrigger asChild>{children}</TooltipTrigger>
      <TooltipContent
        side={position}
        sideOffset={4}
        className="max-w-[240px] break-all"
      >
        {title}
      </TooltipContent>
    </Tooltip>
  );
};

export default TooltipWrapper;
